import styles from './skeleton.module.scss';

interface SkeletonLoaderProps {
  width?: string;
  height?: string;
  flexShrink?: number;
  styleOption?: string;
}

export const SkeletonLoader = ({
  width = '100%',
  height = '20px',
  flexShrink = 0,
  styleOption = '',
}: SkeletonLoaderProps) => {
  return (
    <div
      className={`${styles['skeleton-loader']} ${styleOption}`}
      style={{ width, height, flexShrink }}
    />
  );
};
